module.exports = __webpack_public_path__ + "static/media/logo-the-property-ombudsman.d6cdf8e1.png";